import { client } from '../services/client'
import { QUERY } from '../services/queries'

export async function getToken(auth_id, email) {
  let response

  try {
    response = await client.mutate({
      mutation: QUERY.TOKEN.GET,
      variables: {
        payload: {
          auth_id,
          email,
          origen: 'ADMIN_DASHBOARD',
        },
      },
      context: { clientName: 'apiProducer' },
    })
  } catch (error) {
    const statusCode = error?.networkError?.statusCode ?? error?.networkError?.status
    if (Number(statusCode) === 403) {
      throw new Error('Producer auth rejected user (403)')
    }
    throw new Error(`Producer auth request failed: ${error?.message || 'unknown error'}`)
  }

  const auth = response?.data?.auth
  const responseCode = Number(auth?.HTTP_status?.code)
  console.info(`[ProducerAuth] Producer auth response code: ${auth?.HTTP_status?.code ?? 'unknown'}`)

  if (responseCode === 403) {
    throw new Error('Producer auth rejected user (403)')
  }

  if (!Number.isInteger(responseCode) || responseCode < 200 || responseCode >= 300) {
    throw new Error(`Producer auth failed with status ${auth?.HTTP_status?.code ?? 'unknown'}`)
  }

  if (typeof auth?.token !== 'string' || !auth.token) {
    throw new Error('Producer auth returned no token')
  }

  return auth.token
}
